import { createTheme } from "@mui/material/styles";

/**
 * Dense dark theme. This is a console an operator keeps open next to a phone dialer
 * for hours, so the priorities are rows-per-screen and legible tabular numbers
 * rather than generous whitespace.
 */
export const theme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: "#4f9dff" },
    secondary: { main: "#f2a63b" },
    background: { default: "#0f1115", paper: "#171a21" },
    success: { main: "#4caf7d" },
    warning: { main: "#e0a300" },
    error: { main: "#e5484d" },
  },
  shape: { borderRadius: 6 },
  typography: {
    fontFamily: ['"Inter"', "system-ui", "-apple-system", "Segoe UI", "Roboto", "sans-serif"].join(","),
    fontSize: 13,
    h5: { fontSize: "1.25rem", fontWeight: 600 },
    h6: { fontSize: "1.0625rem", fontWeight: 600 },
    // Counts and IDs sit in tables and must line up column to column.
    body2: { fontVariantNumeric: "tabular-nums" },
  },
  components: {
    // Raw <a> elements (react-router's <Link> renders one) fall back to the
    // browser's own link colors -- 1996 blue and visited-purple -- which on this
    // dark palette read as a rendering bug. CssBaseline applies these globally,
    // so a bare anchor anywhere in the console inherits the theme instead of
    // depending on every callsite remembering to wrap it in MUI's <Link>.
    MuiCssBaseline: {
      styleOverrides: {
        a: {
          color: "#4f9dff",
          textDecorationColor: "rgba(79, 157, 255, 0.4)",
          "&:visited": { color: "#4f9dff" },
          "&:hover": { color: "#7db8ff" },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: { paddingTop: 6, paddingBottom: 6, fontSize: "0.8125rem" },
        head: { fontWeight: 600, whiteSpace: "nowrap" },
      },
    },
    MuiButton: { defaultProps: { size: "small" }, styleOverrides: { root: { textTransform: "none" } } },
    MuiTextField: { defaultProps: { size: "small" } },
    MuiSelect: { defaultProps: { size: "small" } },
    MuiChip: { defaultProps: { size: "small" } },
    MuiIconButton: { defaultProps: { size: "small" } },
    MuiTooltip: { defaultProps: { arrow: true } },
  },
});

/** Monospace stack for ids, cursors, cron expressions and JSON editors. */
export const MONO = ['"SFMono-Regular"', "Menlo", "Consolas", "monospace"].join(",");
